module.exports = __webpack_public_path__ + "static/media/MK 9 upd.0947f878.mp3";